/* eslint-disable sonarjs/no-all-duplicated-branches */
import React, { FC, useRef } from 'react';
import classNames from 'classnames';
import { useStore } from '@/zustand/store/store';
import CommandPointList from '../LeftBox/UserDataSection/CommandPointList';
import LoginSection from '../LoginSection';
import CommandCenterGamelog from './Gamelog';
import GlobalStatsSection from './GlobalStatsSection';
import MyStatsSection from './MyStatSection';
import TotalSoldier from './TotalSoldier';
import AchievementsContent from '@/components/Achievements/AchievementsContent';
import useAuthStatuses from '@/hooks/authentication/useAuthStatuses';
import MediaBanner from '@/components/Builder/CommandCenterBanner/MediaBanner2';

interface ComponentProps {
  pointListRef: React.RefObject<HTMLDivElement>;
}

const CenterBox: FC<ComponentProps> = ({ pointListRef }) => {
  const itemRef = useRef(null);
  const { isLogin } = useAuthStatuses();
  const { showPointList } = useStore();
  // const { isMobile, isTablet, isDesktop, isDesktop1440 } = useResponsive();

  // let imageCommanders = isMobile
  //   ? '/images/commanderBanner/all-commander-mobile.jpg'
  //   : isTablet
  //   ? '/images/commanderBanner/all-commander-mini-desktop.jpg'
  //   : isDesktop
  //   ? '/images/commanderBanner/all-commander-mini-desktop.jpg'
  //   : isDesktop1440
  //   ? '/images/commanderBanner/all-commander-desktop.jpg'
  //   : '/images/commanderBanner/all-commander-desktop.jpg';

  return (
    <div className='w-full lg:w-[calc(100%-400px)]'>
      <div
        ref={pointListRef}
        className={classNames(' w-full h-[117px]', showPointList ? 'max-h-[117px] opacity-100' : 'max-h-[0px] opacity-0 overflow-hidden ')}
        style={{ transition: ' max-height 0.3s ease-in-out, opacity 0.3s ease-in-out' }}
      >
        <div className='h-full pb-2'>
          <CommandPointList />
        </div>
      </div>
      <div
        ref={itemRef}
        className={classNames(!showPointList ? 'block' : 'hidden', 'w-full grid grid-cols-12 grid-rows-1 gap-y-2 xl:gap-y-1 lg:gap-x-2')}
      >
        <div className='col-span-12 xl:col-span-5 bg-[#3C3B3B] bg-opacity-40 rounded-[10px] px-2 py-1 grid grid-cols-12'>
          {isLogin ? (
            <MyStatsSection />
          ) : (
            <div className='col-span-12 xl:col-span-5 h-full'>
              <LoginSection isHorizontal />
            </div>
          )}
        </div>
        <div className='col-span-12 xl:hidden'>
          <GlobalStatsSection />
        </div>
        <div className='hidden xl:block xl:col-span-5'>
          <GlobalStatsSection />
        </div>
        <TotalSoldier />
        <div className='col-span-12 xl:col-span-10'>
          <CommandCenterGamelog />
        </div>
      </div>
      <div>
        {/* <BuilderComponent model='taskcenter-banner' content={commandCenterBar} /> */}
        <div className='h-[260px] xl:h-[250px] w-full relative rounded-[10px] overflow-hidden my-2'>
          {/* <Image src={imageCommanders} layout='fill' objectFit='contain' alt='al-commander' /> */}
          <MediaBanner />
          {/* <Banner /> */}
        </div>
      </div>
      <AchievementsContent />
    </div>
  );
};

CenterBox.displayName = 'CenterBox';

export default CenterBox;
